<template>
    <div class="card" id="Device" >
        <div class="card-header" style="display:flex">
            <h3 class="card-title">رانندگان</h3>
            <div style="flex-grow:1">

            </div>
            <CButton    color="outline-primary" style="border-bottom-left-radius: 2px;border-top-left-radius: 2px;border-top-right-radius: 2px;border-bottom-right-radius: 2px" @click="[isShowAdvancedSearch=!isShowAdvancedSearch,$store.state.Drivers.RequestResponse=[]]"><CIcon name="cil-search"/>&nbsp;&nbsp;جستجوی پیشرفته </CButton>
        </div>
        <div class="card-body" style="display:flex;flex-direction:column;gap:10px">
            <CCollapse  :show="isShowAdvancedSearch"  :duration="300">
                <CCardBody style="display:flex;flex-direction:column;gap:10px">
                    <div style="display:flex;gap:10px">
                        <CInput v-model="AdvancedSearch.FleetName" style="flex-grow: 1;" label="نام خط"/>
                        <CInput v-model="AdvancedSearch.VehicleName" style="flex-grow: 1;" label="نام خودرو"/>
                        <CInput v-model="AdvancedSearch.FirstName" style="flex-grow: 1;" label="نام"/>
                    </div>
                    <div style="display:flex;gap:10px">
                        <CInput v-model="AdvancedSearch.LastName" style="flex-grow: 1;" label="نام خانوادگی"/>
                        <CInput v-model="AdvancedSearch.NationalCode" style="flex-grow: 1;" label="کد ملی"/>
                        <CInput v-model="AdvancedSearch.Phone" style="flex-grow: 1;"  label="شماره تلفن"/>
                    </div>
                    <div style="display:flex;gap:10px">
                        <div style="flex-grow: 1;"></div>
                            <CButton v-if="$store.state.InlineLoading.Device_AdvancedSearch" disabled=""    color="primary" style="border-bottom-left-radius: 2px;border-top-left-radius: 2px;border-top-right-radius: 2px;border-bottom-right-radius: 2px">
                                <b-spinner small></b-spinner>
                                <span class="sr-only">درحال جستجو...</span>
                                </CButton>
                            <CButton v-else    color="primary" style="border-bottom-left-radius: 2px;border-top-left-radius: 2px;border-top-right-radius: 2px;border-bottom-right-radius: 2px" @click="Driver_AdvancedSearch()"><CIcon name="cil-search"/>&nbsp;&nbsp;جستجو </CButton>
                        </div>

                </CCardBody>
            </CCollapse>
            <div class="input-group" style="direction: rtl" v-if="!isShowAdvancedSearch">
                <span class="input-group-text" style="min-width: 100px">انتخاب خط</span>
                <input class="form-control" disabled  v-model="Fleet.FleetName" type="text"   aria-describedby="basic-addon1">
                <CButton @click="DialogSelectFleet = true" color="primary" style="border-bottom-left-radius: 2px;border-top-left-radius: 2px">انتخاب</CButton>
                <CButton v-if="Fleet.FleetName!==''"  color="warning" style="border-bottom-left-radius: 2px;border-top-left-radius: 2px;border-top-right-radius: 2px;border-bottom-right-radius: 2px" @click="SelectFleet">بروز رسانی</CButton>
                <CButton v-else disabled  color="warning" style="border-bottom-left-radius: 2px;border-top-left-radius: 2px;border-top-right-radius: 2px;border-bottom-right-radius: 2px">بروز رسانی</CButton>
            </div>
            <CDataTable
                    :hover="true"
                    :border="true"
                    :striped="true"
                    :small="true"
                    :items="$store.state.Drivers.RequestResponse"
                    :fields="fields"
                    :fixed="true"
                    :loading="false"
                    @row-clicked="SelectDriver"
                    :tableFilterValue="TableFilter"
                    :clickableRows="true"
                    :items-per-page="7"
                    pagination
                    :noItemsView="{ noResults: 'چیزی یافت نشد.', noItems: 'چیزی برای نمایش وجود ندارد.' }"
            >
                <template #details="{item}">
                    <CCollapse :show="item.DriverID===indexDriverSelect"  :duration="500">
                        <CCardBody style="float: right;width: 100%;height:400px ;border: 1px solid silver">
                            <div style="float: right;width: auto;max-width:600px;margin-top: 5px;margin-right: 20px">
                                <div class="input-group" style="direction: rtl;float: right;width: 300px;">
                                    <span class="input-group-text" style="min-width: 120px;background: #212525;color: white">نام</span>
                                    <input class="form-control" disabled v-model="Personnel.Name" type="text" style="text-align: center;background: #212529;color: white" >
                                </div>
                                <div class="input-group" style="direction: rtl;float: right;width: 300px;">
                                    <span class="input-group-text" style="min-width: 120px;background: #212525;color: white">نام خانوادگی</span>
                                    <input class="form-control" disabled v-model="Personnel.FamilyName" type="text" style="text-align: center;background: #212529;color: white" >
                                </div>
                                <div class="input-group" style="direction: rtl;float: right;width: 300px;">
                                    <span class="input-group-text" style="min-width: 120px;background: #212525;color: white">رفرنس</span>
                                    <input class="form-control" disabled v-model="Personnel.Refrence" type="text" style="text-align: center;background: #212529;color: white" >
                                </div>
                                <div class="input-group" style="direction: rtl;float: right;width: 300px;">
                                    <span class="input-group-text" style="min-width: 120px;background: #212525;color: white">Personal ID</span>
                                    <input class="form-control" disabled v-model="Personnel.Personal_ID" type="text" style="text-align: center;background: #212529;color: white" >
                                </div>
                                <div class="input-group" style="direction: rtl;float: right;width: 300px;">
                                    <span class="input-group-text" style="min-width: 120px;background: #212525;color: white">ملیت</span>
                                    <input class="form-control" disabled v-model="Personnel.Nationality" type="text" style="text-align: center;background: #212529;color: white" >
                                </div>
                                <div class="input-group" style="direction: rtl;float: right;width: 300px;">
                                    <span class="input-group-text" style="min-width: 120px;background: #212525;color: white">تاریخ استخدام</span>
                                    <input class="form-control" v-model="Personnel.HireDate"   style="text-align: center;background: #212529;color: white" >
                                </div>
                                <div class="input-group" style="direction: rtl;float: right;width: 300px;">
                                    <span class="input-group-text" style="min-width: 120px;background: #212525;color: white">تاریخ انفصال</span>
                                    <input class="form-control" v-model="Personnel.LeaveDate"   style="text-align: center;background: #212529;color: white" >
                                </div>
                                <div class="input-group" style="direction: rtl;float: right;width: 300px;">
                                    <span class="input-group-text" style="min-width: 120px;background: #212525;color: white">HomeLocationID</span>
                                    <input class="form-control" disabled v-model="Personnel.HomeLocationID" type="text" style="text-align: center;background: #212529;color: white" >
                                </div>
                                <div class="input-group" style="direction: rtl;float: right;width: 300px;">
                                    <span class="input-group-text" style="min-width: 120px;background: #212525;color: white">شماره ثابت 1</span>
                                    <input class="form-control" disabled v-model="Personnel.Tel1" type="text" style="text-align: center;background: #212529;color: white" >
                                </div>
                                <div class="input-group" style="direction: rtl;float: right;width: 300px;">
                                    <span class="input-group-text" style="min-width: 120px;background: #212525;color: white">شماره ثابت 2</span>
                                    <input class="form-control" disabled v-model="Personnel.Tel2" type="text" style="text-align: center;background: #212529;color: white" >
                                </div>
                                <div class="input-group" style="direction: rtl;float: right;width: 300px;">
                                    <span class="input-group-text" style="min-width: 120px;background: #212525;color: white">موبایل 1</span>
                                    <input class="form-control" disabled v-model="Personnel.Mobile1" type="text" style="text-align: center;background: #212529;color: white" >
                                </div>
                                <div class="input-group" style="direction: rtl;float: right;width: 300px;">
                                    <span class="input-group-text" style="min-width: 120px;background: #212525;color: white">موبایل 2</span>
                                    <input class="form-control" disabled v-model="Personnel.Mobile2" type="text" style="text-align: center;background: #212529;color: white" >
                                </div>
                                <div class="input-group" style="direction: rtl;float: right;width: 300px;">
                                    <span class="input-group-text" style="min-width: 120px;background: #212525;color: white">ایمیل</span>
                                    <input class="form-control" disabled v-model="Personnel.Email" type="text" style="text-align: center;background: #212529;color: white" >
                                </div>
                                <div class="input-group" style="direction: rtl;float: right;width: 300px;">
                                    <span class="input-group-text" style="min-width: 120px;background: #212525;color: white">توضیحات</span>
                                    <input class="form-control" disabled v-model="Personnel.Description" type="text" style="text-align: center;background: #212529;color: white" >
                                </div>
                                <div class="input-group" style="direction: rtl;float: right;width: 300px;">
                                    <span class="input-group-text" style="min-width: 120px;background: #212525;color: white">تصویر</span>
                                    <input class="form-control" disabled v-model="Personnel.Picture" type="text" style="text-align: center;background: #212529;color: white" >
                                </div>
                                <div class="input-group" style="direction: rtl;float: right;width: 300px;">
                                    {{item.DateCreate}}
                                    <span class="input-group-text" style="min-width: 120px;background: #212525;color: white">تاریخ ایجاد</span>
                                    <input class="form-control" v-model="Personnel.DateCreate"   style="text-align: center;background: #212529;color: white" >
                                </div>
                                <div class="input-group" style="direction: rtl;float: right;width: 300px;">
                                    <span class="input-group-text" style="min-width: 120px;background: #212525;color: white">تاریخ بروز رسانی</span>
                                    <input class="form-control" v-model="Personnel.DateUpdate"   style="text-align: center;background: #212529;color: white" >
                                </div>
                            </div>

                        </CCardBody>
                    </CCollapse>
                </template>
                
                <template #FullName="{item}">
                    <td style="font-size: 16px">
                        <CBadge v-if="item.NaFamilyNameme===null" color="warning" > نا مشخص</CBadge>
                        <CBadge v-else color="info" v-text="item.Name+' '+item.FamilyName"></CBadge>
                    </td>
                </template>
                <template #Mobile1="{item}">
                    <td style="font-size: 16px">
                        <CBadge v-if="item.Mobile1===null" color="warning" > شماره موجود نیست</CBadge>
                        <CBadge v-else-if="item.Mobile1.length<6" color="warning"> شماره موجود نیست</CBadge>
                        <CBadge v-else color="info" v-text="item.Mobile1"></CBadge>
                    </td>
                </template>
                <template #Action="{item}">
                    <td>
                        <CButton   color="primary" style="border-bottom-left-radius: 2px;border-top-left-radius: 2px;border-top-right-radius: 2px;border-bottom-right-radius: 2px" @click="EditDriver(item)">ویرایش</CButton>
                    </td>
                </template>
            </CDataTable>
        </div>
        <div class="card-footer" style="display:flex;direction:ltr;gap:10px">

            <MPrint 
                v-if="$store.state.Drivers.RequestResponse.length>0"
                :data="$store.state.Drivers.RequestResponse"
            
                label="PDF" 
                title="رانندگان"
                :fields="fields">
            </MPrint>
        </div>
       <CModal
                title=""
                color="info"
                :closeOnBackdrop="false"
                :size="'sm'"
                :show.sync="DialogSelectFleet"
        >
            <div style="direction: rtl;text-align: right;diaply:flex;flex-direction:column">
                <CInput v-model="TextSearchFleet" placeholder="جستجو" label="نام خط"/>
                <div >
                    <select class="form-select"  size="10" v-model="indexFleet">
                        <option v-for="(fleet,index) in GetFleetsSearch($store.state.Fleets.RequestResponse,TextSearchFleet)" :value="index" v-text="fleet.FleetName" v-bind:key="index"></option>
                    </select>
                </div>
            </div>
            <template #header>

                <h4 class="modal-title" style="direction: rtl"> <CIcon name="cil-sun" width="20px" height="20px"/>&nbsp;&nbsp; انتخاب خط </h4>

            </template>
            <template #footer>
                <CButton @click="DialogSelectFleet = false" color="danger">بستن</CButton>
                <CButton @click="SelectFleet()" color="primary">&nbsp;&nbsp;  انتخاب</CButton>
            </template>
        </CModal>
         <CModal
                title=""
                color="info"
                :closeOnBackdrop="false"
                :size="'xl'"
                :show.sync="DialogEditDriver"
        >
           <div style="direction: rtl;text-align: right">
               <CRow>
                   <CCol>
                       <CInput
                            label="شماره شناسایی"
                                v-model="Driver.DriverID"
                                disabled
                            />
                   </CCol>
                   <CCol>
                       <CInput
                            label="نام خانوادگی"
                                v-model="Personnel.FamilyName"
                            />
                        
                   </CCol>
                   <CCol>
                       <CInput
                            label="نام"
                                v-model="Personnel.Name"
                            />
                         
                   </CCol>
               </CRow>
                <br>
               <CRow>
                   <CCol>
                       <CInput
                            label="رفرنس"
                                v-model="Personnel.Refrence"
                            />
                   </CCol>
                   <CCol>
                       <CInput
                            label="Personal_ID"
                                v-model="Personnel.Personal_ID"
                            />
                    
                   </CCol>
                   <CCol>
                       <CRow>
                           <label for="">تاریخ تولد</label>
                       </CRow>
                       <CRow>
                           <div class="input-group" style="direction: rtl">
                        
                                <date-picker style="display:block;position:absolute;left:0;direction: ltr;text-align: right;width: 100%;"  v-model="Personnel.Birthday"  type="date"></date-picker>
                            </div>
                       </CRow>
                        
                   </CCol>
               </CRow>
                <br>
               <CRow>
                   <CCol>
                       <CInput
                            label="ملیت"
                                v-model="Personnel.Nationality"
                            />
                   </CCol>
                   <CCol>
                       <CRow>
                           <label for="">تاریخ استخدام</label>
                       </CRow>
                       <CRow>
                           <div class="input-group" style="direction: rtl">
                        
                                <date-picker style="display:block;position:absolute;left:0;direction: ltr;text-align: right;width:100%;"  v-model="Personnel.HireDate"  type="date"></date-picker>
                            </div>
                       </CRow>
                        
                   </CCol>
                   <CCol>
                       <CRow>
                           <label for="">تاریخ ترک</label>
                       </CRow>
                       <CRow>
                           <div class="input-group" style="direction: rtl">
                                <span class="input-group-text" style="min-width: 130px">تاریخ ترک </span>
                                <date-picker style="display:block;position:absolute;left:0;direction: ltr;text-align: right;width:100%;"  v-model="Personnel.LeaveDate"  type="date"></date-picker>
                            </div>
                       </CRow>
                       
                   </CCol>
               </CRow>
               <br>
               <CRow>
                   <CCol>
                       <CInput
                            label="شماره تلفن 1"
                                v-model="Personnel.Tel1"
                            />
                    
                   </CCol>
                   <CCol>
                         <CInput
                            label="شماره تلفن 1"
                                v-model="Personnel.Tel1"
                            />
                   </CCol>
                   <CCol>
                        <CInput
                            label="شماره موبایل 1"
                                v-model="Personnel.Mobile1"
                            />
                   </CCol>
               </CRow>
                <br>
               <CRow>
                   <CCol>
                       <CInput
                            label="شماره موبایل 2"
                                v-model="Personnel.Mobile2"
                            />
                   </CCol>
                   <CCol>
                       <CInput
                            label="ایمیل"
                                v-model="Personnel.Email"
                            />
                    
                   </CCol>
                   <CCol>
                       <CInput
                            label="توضیحات"
                                v-model="Personnel.Description"
                            />
                   </CCol>
               </CRow>
            </div>
            <template #header>

                <h4 class="modal-title" style="direction: rtl"> <CIcon name="cil-sun" width="20px" height="20px"/>&nbsp;&nbsp; ویرایش راننده </h4>

            </template>
            <template #footer>
                <CButton @click="DialogEditDriver = false" color="warning">انصراف</CButton>
                <CButton  color="info" @click="UpdateDriver">&nbsp;&nbsp;  به روز رسانی </CButton>
            </template>
        </CModal>
        <div class="toast fade show" v-if="Toast.show" role="alert" aria-live="assertive" aria-atomic="true"  style="position: fixed;bottom: 10px;left:10px;direction: rtl;text-align: right;z-index: 8000">
            <div class="toast-header" v-if="Toast.state ==='success'">
                <svg class="docs-placeholder-img rounded me-2" width="20" height="20" xmlns="http://www.w3.org/2000/svg" aria-hidden="true" preserveAspectRatio="xMidYMid slice" focusable="false">
                    <rect width="100%" height="100%" fill="green"></rect>
                </svg><strong class="me-auto" style="float: right;width: auto">{{Toast.title}}</strong>
            </div>
            <div v-else-if="Toast.state ==='error'" class="toast-header" >
                <svg class="docs-placeholder-img rounded me-2" width="20" height="20" xmlns="http://www.w3.org/2000/svg" aria-hidden="true" preserveAspectRatio="xMidYMid slice" focusable="false">
                    <rect width="100%" height="100%" fill="red"></rect>
                </svg><strong class="me-auto" style="float: right;width: auto">{{Toast.title}}</strong>
            </div>
            <div class="toast-body">{{Toast.message}}</div>
        </div>
    </div>
</template>

<script>
    import Vue from 'vue'
    import Constant from './../../assets/Constants'
    export default {
        name: "Drivers",
        data(){
            return {
                isShowAdvancedSearch:false,
                Toast:{
                    message:'',
                    title:"",
                    duration:3000,
                    show:false,
                    state:"success",
                },
                User:null,
                Fleets: [],
                Drivers: [],
                Driver: {},
                Personnel: {
                    HireDate:'1400/01/01',
                    Birthday:'1373/12/20',
                    LeaveDate:'1401/12/20',
                    Picture:'T',
                },
                indexFleet:0,
                indexDriverSelect:0,
                Fleet:{FleetName:""},
                DialogSelectFleet:false,
                DialogEditDriver:false,
                TableFilter:'',
                AdvancedSearch:{
                    FleetName:'',
                    VehicleName:'',
                    FirstName:'',
                    LastName:'',
                    NationalCode:'',
                    Phone:'',
                },
                TextSearchFleet:"",
                fields:[{"key":"DriverID","label":"شناسه راننده"},{"key":"FullName","label":"نام خانوادگی"},{"key":"Mobile1","label":"شماره موبایل"},{"key":"Action","label":"عملکرد"}],
            }
        },
        computed:{
            ReadPersonal(){
                return this.$store.state.Personal;
            }
        },
        watch:{
            ReadPersonal(data){
                console.log('----------------------')
                console.log(data)
                if(data.Status!==undefined){
                    if(data.Status){
                        if(data.RequestResponse.length>0){
                            this.Personnel=data.RequestResponse[0];
                            if(this.Personnel.Birthday===null){
                                this.Personnel.Birthday='1401-12-20';
                                this.Personnel.HireDate='1401-12-20';
                                this.Personnel.LeaveDate='1401-12-20';
                            }
                            else{
                                this.Personnel.Birthday=Vue.moment(this.Personnel.Birthday, 'YYYY-MM-DDt00:00:00').format('jYYYY/jMM/jDD');
                                this.Personnel.HireDate=Vue.moment(this.Personnel.HireDate, 'YYYY-MM-DDt00:00:00').format('jYYYY/jMM/jDD');
                                this.Personnel.LeaveDate=Vue.moment(this.Personnel.LeaveDate, 'YYYY-MM-DDt00:00:00').format('jYYYY/jMM/jDD');
                            }
                        }
                    }
                }
                    
                
                
                
            }
        },
        mounted() {
            if(this.$session.has("User")){
                this.User= this.$session.get("User");
                console.log("User-->"+this.User);
            }
            this.GetFleets();
        },
        methods:{
            GetFleets(){
                this.$store.commit('FleetByUser');
            },
            GetPersonal(id){
                this.$store.commit('Personnel_GetByID',{
                        PersonalID:id
                    });
            },
            SelectFleet()
            {
                var fleets=this.GetFleetsSearch(this.$store.state.Fleets.RequestResponse,this.TextSearchFleet);
                this.Fleet=fleets[this.indexFleet];
                this.DialogSelectFleet=false;
                this.GetDriversByFleet(this.Fleet.FleetID);
            },
            GetDriversByFleet(fleetID){
                this.$store.commit('Driver_GetByFleetID',{
                    FleetID:fleetID
                    });
            },
            EditDriver(item){
                this.DialogEditDriver=true;
                this.Driver=item;
                this.GetPersonal(this.Driver.PersonnelID)
            },
            UpdateDriver(){
                var that=this;
                var timeNow=Vue.moment().format('YYYY_MM_DD_HH_mm_ss');
                if(this.Personnel.FamilyName===null){
                    this.Personnel.FamilyName="null";
                }
                if(this.Personnel.Refrence===null){
                    this.Personnel.Refrence='ندارد';
                }
                if(this.Personnel.Name===null){
                    this.Personnel.Name="null";
                }
                if(this.Personnel.Personal_ID===null){
                    this.Personnel.Personal_ID="0";
                }
                console.log(this.Personnel.Birthday)
                if(this.Personnel.Birthday===null){
                    this.Personnel.Birthday='1373/12/20'
                    
                }
                if(this.Personnel.Nationality===null){
                    this.Personnel.Nationality=0;
                }
                
                if(this.Personnel.HireDate===null){
                    this.Personnel.HireDate='1400/01/01'
                    
                }
                if(this.Personnel.LeaveDate===null){
                    this.Personnel.LeaveDate='1401/12/20'
                }
                if(this.Personnel.Tel1===null){
                    this.Personnel.Tel1="null";
                }
                if(this.Personnel.Tel2===null){
                    this.Personnel.Tel2="null";
                }
                if(this.Personnel.Mobile1===null){
                    this.Personnel.Mobile1="null";
                }
                if(this.Personnel.Mobile2===null){
                    this.Personnel.Mobile2="null";
                }
                if(this.Personnel.Email===null){
                    this.Personnel.Email="null";
                }
                if(this.Personnel.Description===null){
                    this.Personnel.Description="null";
                }
                if(this.Personnel.Picture===null){
                    this.Personnel.Picture=1;
                }
                this.$store.commit('Driver_Update',{
                    ID:this.Driver.DriverID,
                    FamilyName:this.Personnel.FamilyName,
                    Refrence:this.Personnel.Refrence,
                    Name:this.Personnel.Name,
                    Personal_ID:this.Personnel.Personal_ID,
                    Birthday:Vue.moment(this.Personnel.Birthday, 'jYYYY/jMM/jDD').format('YYYY_MM_DD_00_00_00'),
                    Nationality:this.Personnel.Nationality,
                    HireDate:Vue.moment(this.Personnel.HireDate, 'jYYYY/jMM/jDD').format('YYYY_MM_DD_00_00_00'),
                    LeaveDate:Vue.moment(this.Personnel.LeaveDate, 'jYYYY/jMM/jDD').format('YYYY_MM_DD_00_00_00'),
                    Tel1:this.Personnel.Tel1,
                    Tel2:this.Personnel.Tel2,
                    Mobile1:this.Personnel.Mobile1,
                    Mobile2:this.Personnel.Mobile2,
                    Email:this.Personnel.Email,
                    Description:this.Personnel.Description,
                    Picture:this.Personnel.Picture,
                    DateUpdate:timeNow,
                    });
                    this.DialogEditDriver=false;
                
            },
            SelectDriver(item, index, columnname, event){
                if(columnname !== "details" && columnname !== "Action") {
                    if (this.indexDriverSelect === -1) {
                        this.Driver = item;
                        this.indexDriverSelect = item.DriverID;
                        this.TableFilter = item.Name;
                        this.GetPersonal(item.DriverID);

                    } else {
                        this.indexDriverSelect = -1;
                        this.Driver = {};
                        var that=this;
                        setTimeout(function() {
                            that.TableFilter ="";
                        }, 700);
                    }
                }
            },
            GetDateTime(time){
                console.log("GetDateTime");
                console.log(time);
                if(time.length>5)
                return Vue.moment(time, "YYYY-MM-DD HH:mm:ss").format("jYYYY-jMM-jDD HH:mm:ss");
                else "نامشخص";
            },
            GetDate(time){
                console.log("GetDate");
                console.log(time);
                if(time.length>5)
                return Vue.moment(time, "YYYY-MM-DD HH:mm:ss").format("jYYYY-jMM-jDD");
                else "dfdfdf";
            },
            MakeToast(title,message,status){
                var that=this;
                that.Toast.title=title;
                that.Toast.message=message;
                that.Toast.show=true;
                that.Toast.state=status;
                setTimeout(function() {
                    that.Toast.show=false;
                }, that.Toast.duration);
            },
            GetFleetsSearch(fleets,txt){
                var items=[];
                for(var i=0;i<fleets.length;i++){
                    var fleet=fleets[i];
                    if(fleet.FleetName.toLowerCase().includes(txt.toLowerCase())){
                        items.push(fleet)
                    }
                }
                return items;
            },
            Driver_AdvancedSearch(){
                this.$store.commit('Driver_AdvancedSearch',{
                    UserID:2188,
                    FleetName:this.AdvancedSearch.FleetName,
                    VehicleName:this.AdvancedSearch.VehicleName,
                    FirstName:this.AdvancedSearch.FirstName,
                    LastName:this.AdvancedSearch.LastName,
                    NationalCode:this.AdvancedSearch.NationalCode,
                    Phone:this.AdvancedSearch.Phone
                });
            }
        }
    }
</script>

<style scoped>

</style>